<template>
  <router-view/>
</template>

<style lang="scss">
@import url(https://fonts.googleapis.com/css2?family=Teko:wght@300..700&display=swap);
.title {
    color: #0A1F44!important;
    font-family: Teko, Sans-serif!important;
    font-size: 50px;
    margin: 0;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    letter-spacing: -1.5px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
